import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part5 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic27: 'medsurg-cinematic-2-27',
        chapterCinematic28: 'medsurg-cinematic-2-28',
        chapterCinematic29: 'medsurg-cinematic-2-29',
        chapterCinematic30: 'medsurg-cinematic-2-30',
		chapterCinematic31: 'medsurg-cinematic-2-31',
        chapterCinematic32: 'medsurg-cinematic-2-32',
        chapterCinematic33: 'medsurg-cinematic-2-33',
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Action1: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action2: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private CAbool: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part5.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			list: '<li>Temperature: 98</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			list: '<li>Pulse: 72</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			list: '<li>Respirations: 14</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			list: '<li>Blood Pressure: 118/66</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			list: '<li>Oxygen Saturation: 98%</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			title: 'Vitals - 09:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Lynn Phillips, a 30-year-old Caucasian female patient, has been admitted for a 23-hour observation.</li><li>Patient underwent a diagnostic hysteroscopy procedure where two fibroids were removed</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>two children</li><li>fibroids and bleeding since having children</li><li>menorrhagia</li><li>Caucasian</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>IV of Lactated Ringers (LR)  at 75 ml/hr</li><li>Hydromorphone 1 mg IV push every 3 hours (PRN)</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>LOC normal during pre-op</li><li>Small vaginal bleeding in return fluid post-op</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			// context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		this.scenario.displayModalPop(
			null,
            'Skipping to part 6',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 5',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				context.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '5', '8', false, false);
				context.TalkCount = 5;
				context.ActionCount = 8;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(7050, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			title: 'Vitals - 12:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;


		context.scenario.saveScore();

		context.onDone();

		//this.scenario.showBadgingUI(0, () => {
        //    context.onDone();
        //});
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Lynn Phillips'
				},
				{
					description: 'Room: #5'
				},
				{
					description: 'Age: 30'
				},
				{
					description: 'Sex: Female'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsNursesID),
			lab: [
				{
					title: 'Test Name',
					description1: 'HGB',
					description2: '<div style="color: red" aria-label="12 g over d L. down"> 12 g/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="13.5 to 17.9">13.5 - 17.9</div>'
				},
				{
					title: 'Results',
					description1: 'HCT',
					description2: '<div style="color: red" aria-label="36 g over d L. down"> 36 g/dL <span style="float: right">&#129139;</span></div>', // 7 change to 9 for down arrow
					description3: '<div aria-label="41 to 54">41 - 54</div>'
				},
				{
					title: 'Normal Range'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrPhillipsID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkPain();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment1TalkDay();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: "Do you know why you're here today?",
					onClicked: () => {
						this.segment1TalkWhy();
					},
					disable: () => this.Talk5
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action2
				},
				{
					toppx: '250px',
					titletext: 'Catheter: Check Patency',
					onClicked: () => {
						this.segment1ActionPatency();
					},
					disable: () => this.Action3
				},
				{
					toppx: '350px',
					titletext: 'Catheter: Check drainage color and characateristics',
					onClicked: () => {
						this.segment1ActionDrainage();
					},
					disable: () => this.Action4
				},
				{
					toppx: '450px',
					titletext: 'Catheter: Check Urine Output',
					onClicked: () => {
						this.segment1ActionOutput();
					},
					disable: () => this.Action5
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Check Peri Pad',
					onClicked: () => {
						context.segment1ActionPad();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'Check Skin',
					onClicked: () => {
						context.segment1ActionSkin();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'Check Abdomen',
					onClicked: () => {
						context.segment1ActionAbdomen();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Check IV insertion site',
					onClicked: () => {
						context.segment1ActionIV();
					},
					disable: () => this.Action24
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I'm slightly lightheaded.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
					title: context.scenario.painObservation,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.painObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 8,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Pain Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: "Lightheaded",
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Weak',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Chills',
							onClicked: () => {
							},
						},
						{
							buttontop: '500px',
							buttontext: "Feels Terrible",
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic29, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 50,
			painScaleCorrect: 2,
			extBottom: true,
			extText: "I'd say my pain is a two.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic30, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
		});
	}

	private segment1TalkPain() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "Just some soreness in my abdomen.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 75,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Sore',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Stabbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Aching',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sharp',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Unable to describe",
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 7,
					prequizheight: 7,
					quiztop: '520px',
					maxPoints: 75,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Abdomen',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Back',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Joints',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Shoulder',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Unable to describe",
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic31, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
		});
	}

	private segment1TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Do you know what day it is?',
			isTalks: true,
			extBottom: true,
			extText: "Today is Tuesday.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 1200,
					talktext1: 'Patient Observations',
					talktext2: 'Mental Status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
				this.playVideoChapter(this.chapterIds.chapterCinematic32, () => {
					this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
				});
            }
        );
	}

	private segment1TalkWhy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '470px',
			loadQuiz: true,
			titletext: "Do you know why you're here today?",
			isTalks: true,
			extBottom: true,
			extText: "For observation after my hysteroscopy procedure.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 300,
					talktext1: 'Patient Observation',
					talktext2: 'Mental Status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic33, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.5',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Temperature : 99.5</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '128/78',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Blood Pressure : 128/78</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '80',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Pulse : 80</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '14',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Respirations : 14</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '98% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>02 Sat Level : 98% room air</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPad() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Check Peri Pad',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action21 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'Peri Pad',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'In place; light amount; light pink drainage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'In place; moderate amount; dark red drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'In place; heavy amount; dark red drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'In place; no drainage',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Peri pad is in place with light and pink drainage.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();

            }
        );
	}

	private segment1ActionSkin() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Check Skin',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action22 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'Skin',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Pink',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Warm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Dry',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Cool',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Blotchy',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Damp',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Skin is pink, warm, and dry.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
            }
        );
	}

	private segment1ActionAbdomen() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Check Abdomen',
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Abdomen feels soft and has mild distention.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action23 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Abdomen',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Soft',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Firm',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Rigid',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Distention',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionIV() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Check IV insertion site',
			isTalks: true,
			extTop: true,
			extImg: 't14',
			extText: 'Intact, no redness, no leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action24 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'IV Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No redness',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No leakage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Redness',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Non-intact dressing',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPatency() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Catheter: Check Patency',
			isTalks: true,
			extTop: true,
			extImg: 't15',
			extText: 'Patent',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action3 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Patency',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionDrainage() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Catheter: Check drainage color and characteristics',
			isTalks: true,
			extTop: true,
			extImg: 't15',
			extText: 'Drainage color: Straw',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Catheter',
					talktext2: 'Drainage color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Straw',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: "Amber",
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: "Dark Red",
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 250,
					talktext1: 'Catheter',
					talktext2: 'Drainage characteristics',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionOutput() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'Catheter: Check Urine Output',
			scenario: this,
			isTalks: true,
			extTop: true,
			extImg: 't15',
			extText: 'Output 300 ml',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Urine Output',
					talks: [
						{
							buttontop: '150px',
							buttontext: '500 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '400 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '300 ml',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '100 ml',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment1Part5Debrief();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action21 === true && this.Action22 === true && this.Action23 === true && this.Action24 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action2 = true;
		};
		context.getFooterCounts();
	}
}